import React from 'react';
import PropTypes from 'prop-types';

class Iconfont extends React.Component{
    constructor(props) {
        super(props);
        this.state = {};
    }

    clickFunc (e) {
        const {onClick} = this.props
        if (Object.prototype.toString.call(onClick) === "[object Function]") {
            onClick(e)
        }
    }

    render() {
        const {type, iStyle={}}  = this.props;
        const style = {
            verticalAlign: 'middle',
            position: 'relative',
            lineHeight: 1,
            ...iStyle,
        };
        return (<i style={style} className={`iconfont ${type}`} onClick={(e) => this.clickFunc(e)}></i>);
    }
}

Iconfont.propTypes = {
    type: PropTypes.string.isRequired,
    iStyle: PropTypes.object,
};

export default Iconfont;
